import * as stylex from '@stylexjs/stylex';
import { appLink } from '~components/AppCta';
import { shared } from '~styles';
import { styles } from './styles';
export function Stub({
  linkId
}: {
  linkId: string;
}) {
  return <main {...stylex.props(styles.container)}>
      <h1>Spot unavailable</h1>
      <p {...stylex.props(shared.muted)}>This spot is no longer available.</p>
      <a {...stylex.props(shared.primaryButton, styles.button)} href={appLink(`spots/${linkId}`)}>
        Open in the Tribys app
      </a>
    </main>;
}